import { useEffect, useState } from 'react'
import { Link, NavLink, Outlet, useLocation } from 'react-router-dom'
import { business, hasPublishedEmail, hasPublishedPhone } from '../config/business'
import { Logo } from './Logo'

const navigation = [
  { label: 'Services', to: '/services' },
  { label: 'Pricing', to: '/pricing' },
  { label: 'Service Area', to: '/service-area' },
  { label: 'About', to: '/about' },
  { label: 'FAQ', to: '/faq' },
  { label: 'Contact', to: '/contact' },
]

export function Layout() {
  const [menuOpen, setMenuOpen] = useState(false)
  const location = useLocation()

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: 'instant' })
  }, [location.pathname])

  return (
    <div className="site-shell">
      <header className="site-header">
        <div className="container header-inner">
          <Logo onNavigate={() => setMenuOpen(false)} />
          <button
            className="menu-toggle"
            type="button"
            aria-expanded={menuOpen}
            aria-controls="primary-navigation"
            onClick={() => setMenuOpen((open) => !open)}
          >
            <span aria-hidden="true">{menuOpen ? '×' : '☰'}</span>
            <span className="sr-only">{menuOpen ? 'Close' : 'Open'} navigation</span>
          </button>
          <nav
            className={`primary-nav ${menuOpen ? 'is-open' : ''}`}
            id="primary-navigation"
            aria-label="Primary navigation"
          >
            {navigation.map((item) => (
              <NavLink key={item.to} to={item.to} onClick={() => setMenuOpen(false)}>
                {item.label}
              </NavLink>
            ))}
            <Link className="button button-small" to={business.appointmentPath} onClick={() => setMenuOpen(false)}>
              Request appointment
            </Link>
          </nav>
        </div>
      </header>

      <main id="main-content">
        <Outlet />
      </main>

      <footer className="site-footer">
        <div className="container footer-grid">
          <div>
            <Logo compact />
            <p>{business.description}</p>
            <p className="footer-local">Locally serving the Greater Northwest Arkansas Area.</p>
          </div>
          <div>
            <h2>Explore</h2>
            <ul>
              <li><Link to="/services">Services</Link></li>
              <li><Link to="/pricing">Pricing &amp; estimator</Link></li>
              <li><Link to="/service-area">Service area</Link></li>
              <li><Link to="/about">About Michael</Link></li>
            </ul>
          </div>
          <div>
            <h2>Information</h2>
            <ul>
              <li><Link to="/faq">Frequently asked questions</Link></li>
              <li><Link to="/contact">Contact</Link></li>
              <li><Link to="/privacy">Privacy policy</Link></li>
              <li><Link to="/terms">Service terms</Link></li>
            </ul>
          </div>
          <div>
            <h2>Request service</h2>
            <p>Tell Michael what you need. Availability and final pricing are confirmed before scheduling.</p>
            {hasPublishedEmail && <p><a href={`mailto:${business.email}`}>{business.email}</a></p>}
            <Link className="button button-light" to={business.appointmentPath}>Start a request</Link>
          </div>
        </div>
        <div className="container footer-bottom">
          <p>© {new Date().getFullYear()} {business.name}. All rights reserved.</p>
          <p>{business.legalDisclaimer}</p>
        </div>
      </footer>

      <div className="mobile-actions" aria-label="Quick actions">
        {hasPublishedPhone && <a href={`tel:${business.phone}`}>Call Michael</a>}
        {hasPublishedEmail && <a href={`mailto:${business.email}`}>Email</a>}
        <Link to={business.appointmentPath}>Request appointment</Link>
      </div>
    </div>
  )
}
